import React from 'react';
import Colortheme from '../../Theme/Colortheme';
import { messyBorderStyle } from '../../Utils/StyleUtils';

class BasicButton extends React.Component {

    constructor(props) {
        super(props);
        this.buttonStyle = {
            ...props.style,
            background: props.background ?? Colortheme.buttonColor,
            maxWidth: props.width ?? '100%',
            lineHeight: props.height ?? '100%',
            border: 'none',
            color: props.color ?? '#ffffff',
            fontSize: 'min(calc(10px + 1.5vw), 20px)',
            flex: props.flex,
            cursor: "pointer",
            ...messyBorderStyle("basic_button"),
        };
    }

    render() {
        return (
            <button style={this.buttonStyle} onClick={this.props.onClick}>{this.props.children}</button>
        );
    }
}

export default BasicButton;